import React, { useEffect, useState } from 'react';
import { Dialog } from '../common/Dialog';
import { Button } from '../common/Button';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import * as styles from './LegalDialog.css.ts';

interface ReleaseNotesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ReleaseNotesDialog: React.FC<ReleaseNotesDialogProps> = ({ isOpen, onClose }) => {
  const [changelogContent, setChangelogContent] = useState<string>('');

  useEffect(() => {
    // CHANGELOGを動的にfetch（開発時のHMR対応）
    fetch('/CHANGELOG.md')
      .then(response => response.text())
      .then(text => setChangelogContent(text))
      .catch(error => {
        console.error('Failed to load CHANGELOG:', error);
        setChangelogContent('Failed to load release notes.');
      });
  }, []);

  const footer = (
    <Button variant="primary" onClick={onClose}>
      Close
    </Button>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Release Notes"
      width="lg"
      footer={footer}
    >
      <div className={styles.legalContent}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {changelogContent}
        </ReactMarkdown>
      </div>
    </Dialog>
  );
};
